import type {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { currentFirmSubdomain } from "@firm360/libs/util/browser";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import type { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private localStorage = inject(LocalStorageService);
    private sessionStorage = inject(SessionStorageService);

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        if (
            request.url &&
            (!request.url.startsWith("http") ||
                (environment.apiUrl &&
                    request.url.startsWith(environment.apiUrl)))
        ) {
            const subdomain = currentFirmSubdomain();
            const token =
                this.localStorage.retrieve("authenticationToken") ||
                this.sessionStorage.retrieve("authenticationToken");
            const headers: { [key: string]: string } = {
                "X-FIRM-SUBDOMAIN": subdomain,
                "X-APPTYPE": "WEB",
            };
            if (token) {
                headers["Authorization"] = `Bearer ${token}`;
            }
            request = request.clone({ setHeaders: headers });
        }
        return next.handle(request);
    }
}
